<div class="catalogue">
    <div class="catalogue-header">
        <h1 class="m-0 font-bold" [paint]="first_plan()">
            {{title() || (first_plan_string() + ' Discounts')}}
        </h1>
        <h4 class="m-0">
            {{text() || ('Available on ' + first_plan_string() +' subscription')}}
        </h4>
        <h4 class="m-0 font-bold">
            {{subtext() || 'Access to Discounts on Dining, Experiences, Shopping & More!'}}
        </h4>
    </div>
    <div class="catalogue-content">
        <mat-tab-group mat-align-tabs="center" [mat-stretch-tabs]="false" [dynamicHeight]="true" (swipeleft)="swipe($event.type)" (swiperight)="swipe($event.type)" (animationDone)="animating.set(false)" [selectedIndex]="index()" (selectedIndexChange)="animating.set(true); index.set($event);" [paint]="first_plan()">
            @for(category of category_groups(); track category._id){
                <mat-tab [label]="category.name">
                    <ng-template matTabContent>
                        <div class="tab-container">
                            <item-grid class="px-5" [item_width]="315" [items]="category.brands" [item_template]="brandCard" item_name="Brands" [loading]="category._id == 'Loading'" [isFinal]="true">
                            </item-grid>
                        </div>
                    </ng-template>
                </mat-tab>
            }
        </mat-tab-group>
    </div>
</div>

<ng-template #brandCard let-brand>
    <brand-card class="f-main-center" [brand]="brand"></brand-card>
</ng-template>
